var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as d3 from "d3";
import * as topojson from "topojson-client";
import { ChartMap, MapLegend } from "../svg-elements/module";
import { slugify } from "../utils/slugify.utils";
import { GraphControllerV2 } from "./graph-v2";
import { flattenColumn } from "../d3-services/_helpers";
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    function Map(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    Map.prototype.pre = function () {
        this._addScale('y', 'linear', 'opacity', flattenColumn(this.firstMapping['column']));
        this._addMargin(0, 0, 0, 0);
        this._addPadding(20, 40, 40, 0);
    };
    Map.prototype.init = function () {
        var _this = this;
        this.config.margin.right = 25;
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.display = 'flex';
        container.style.flexDirection = 'row';
        container.style.justifyContent = 'center';
        container.style.alignItems = 'center';
        container.style.width = "100%";
        container.style.maxWidth = "400px";
        container.style.height = "320px";
        container.style.marginTop = "-5%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.chartMap = new ChartMap(this);
        this.chartMap.init();
        this.legend = new MapLegend(this);
        // get geodata.js
        d3.json('https://img.publikaan.nl/geojson/gemeenten2021.topojson').then(function (topojsonObject) {
            _this.topojsonObject = topojsonObject;
            _this.update(_this.data, _this.segment, false);
        });
    };
    Map.prototype.prepareData = function (data) {
        var geojson = topojson.feature(this.topojsonObject, this.topojsonObject.objects.gemeenten);
        var features = geojson.features;
        var _loop_1 = function (feature) {
            var muni = data.filter(function (m) {
                return m.gemeente === slugify(feature.properties.gemeentenaam).toLowerCase();
            })[0];
            if (muni && Object.entries(muni).length > 0) {
                for (var _a = 0, _b = Object.entries(muni); _a < _b.length; _a++) {
                    var prop = _b[_a];
                    feature.properties[prop[0]] = prop[1];
                }
            }
            feature.properties.colour = this_1.firstMapping['colour'];
        };
        var this_1 = this;
        for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
            var feature = features_1[_i];
            _loop_1(feature);
        }
        return {
            latest: null,
            slice: null,
            history: null,
            features: features
        };
    };
    Map.prototype.draw = function (data) {
        this.chartMap.draw(data.features); //   if (window.innerWidth < breakpoints.sm) {
        this.element.appendChild(this.legend.draw(data));
    };
    Map.prototype.redraw = function (data) {
        var _this = this;
        this.scales.y.set(data.features.map(function (f) { return (f['properties'][_this.parameters.y] !== undefined) ? f['properties'][_this.parameters.y] : 0; }));
        _super.prototype.redraw.call(this, data);
        this.chartMap.redraw(this.parameters.y, this.mapping.parameters[0][0]['colour']);
    };
    Map.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return Map;
}(GraphControllerV2));
export default Map;
